(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const ElementIds = {
    cartDrawer: "cartDrawer",
    cartDrawerCloseBtn: "cartDrawerCloseBtn",
    cartLoadingOverlay: "cartLoadingOverlay",
  };

  const ElementClassNames = {
    cartDrawerList: "cart-drawer__list",
    cartDrawerListItem: "cart-drawer__list-item",
    cartDrawerError: "cart-drawer__error",
    cartDrawerErrorMessage: "cart-drawer__error-message",
    cartDrawerItemQuantityDecrease: "cart-drawer__list-item__details-quantity-decrease",
    cartDrawerItemQuantityIncrease: "cart-drawer__list-item__details-quantity-increase",
  };

  const cartDrawer = document.getElementById(ElementIds.cartDrawer);
  const cartDrawerCloseBtn = document.getElementById(ElementIds.cartDrawerCloseBtn);
  const cartDrawerList = Array.from(document.getElementsByClassName(ElementClassNames.cartDrawerList))[0];
  const cartDrawerError = Array.from(document.getElementsByClassName(ElementClassNames.cartDrawerError))[0];
  const cartDrawerErrorMessage = Array.from(document.getElementsByClassName(ElementClassNames.cartDrawerErrorMessage))[0];

  const settings = {
    htmlOverflow: document.body.parentElement.style.overflow,
    updatedVariantId: undefined,
  };

  cartDrawer.addEventListener("close", () => {
    cartDrawer.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "unset";
    document.body.parentElement.style.overflow = settings.htmlOverflow;
  });

  function openCart() {
    cartDrawer.showModal();
    cartDrawer.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    document.body.parentElement.style.overflow = "unset";
  }

  document.addEventListener(EventIds.OpenCart, openCart);

  cartDrawerCloseBtn.addEventListener("click", () => {
    cartDrawer.close();
  });

  function startLoading() {
    cartLoadingOverlay.style.display = "flex";
  }

  function stopLoading() {
    cartLoadingOverlay.style.display = "none";
  }

  async function submitUpdateItemQuantity(line, quantity, variantId) {
    const data = {
      line,
      quantity,
      sections: ["header"],
      sections_url: window.location.pathname,
    };

    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "accept": "application/json",
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Item quantity updated:', { variantId, line, quantity });
      if (data?.sections?.header) {
        const items = Array.from(document.getElementsByClassName(ElementClassNames.cartDrawerListItem));
        items.forEach((item) => {
          SectionRenderer.render(`#${item.id}`, data.sections.header);
        })

        SectionRenderer.render(".desktop__nav__cart-button", data.sections.header);
        SectionRenderer.render(".mobile__nav__cart-button", data.sections.header);
        SectionRenderer.render(".cart-drawer__checkout-total", data.sections.header);
      }

      if (data.errors) {
        cartDrawerError.style.display = "block";
        cartDrawerErrorMessage.innerHTML = data.errors;
      } else {
        cartDrawerError.style.display = "none";
        cartDrawerErrorMessage.innerHTML = "";
      }
    })
    .catch((error) => {
      console.error('Error adding item to cart:', error);
      cartDrawerError.style.display = "block";
      cartDrawerErrorMessage.innerHTML = error.message;
      stopLoading();
    });
  }

  async function updateItemQuantity(line, quantity, variantId) {
    startLoading();
    await submitUpdateItemQuantity(line, quantity, variantId);
  }

  async function decreaseQuantityEventHandler(e) {
    e.preventDefault();

    const index = e.currentTarget.dataset.index;
    const quantity = e.currentTarget.dataset.quantity;
    const newQuantity = Number(quantity) - 1;
    const variantId = e.currentTarget.dataset.variantId;
    settings.updatedVariantId = variantId;

    await updateItemQuantity(index, newQuantity, variantId);
  }

  async function increaseQuantityEventHandler(e) {
    e.preventDefault();

    const index = e.currentTarget.dataset.index;
    const quantity = e.currentTarget.dataset.quantity;
    const newQuantity = Number(quantity) + 1;
    const variantId = e.currentTarget.dataset.variantId;
    settings.updatedVariantId = variantId;

    await updateItemQuantity(index, newQuantity, variantId);
  }

  function rebindQuantityEventListener(variantId) {
    const lineItem = document.getElementById(`item-${variantId}`);
    if (lineItem) {
      const increaseBtn = lineItem.querySelector(`.${ElementClassNames.cartDrawerItemQuantityIncrease}`);
      const decreaseBtn = lineItem.querySelector(`.${ElementClassNames.cartDrawerItemQuantityDecrease}`);

      increaseBtn.addEventListener("click", increaseQuantityEventHandler);
      decreaseBtn.addEventListener("click", decreaseQuantityEventHandler);
    }
  }

  function rebindAllQuantityEventListeners() {
    const cartDrawerItemQuantityDecrease = Array.from(document.getElementsByClassName(ElementClassNames.cartDrawerItemQuantityDecrease));
    const cartDrawerItemQuantityIncrease = Array.from(document.getElementsByClassName(ElementClassNames.cartDrawerItemQuantityIncrease));

    cartDrawerItemQuantityDecrease.forEach(btn => {
      btn.addEventListener("click", decreaseQuantityEventHandler);
    })

    cartDrawerItemQuantityIncrease.forEach(btn => {
      btn.addEventListener("click", increaseQuantityEventHandler);
    });
  }

  function updateEventHandlers(...args) {
    if (settings.updatedVariantId) {
      settings.updatedVariantId = undefined;
    }
    stopLoading();
    rebindAllQuantityEventListeners();
  }

  const observer = new MutationObserver(updateEventHandlers);
  observer.observe(cartDrawerList, { childList: true, subtree: true });

  rebindAllQuantityEventListeners();
  } catch(e) { console.error(e); }
})();

})();
